import { MdOutlinePix } from "react-icons/md";
import {
  TbArrowsExchange,
  TbBuildingBank,
  TbTransfer,
  TbWorld,
  TbWorldDollar,
} from "react-icons/tb";

const RAIL_ICONS = {
  pix: MdOutlinePix,
  wire: TbWorldDollar,
  ach: TbTransfer,
  sepa: TbWorld,
  swift: TbArrowsExchange,
  local: TbBuildingBank,
};

export const PaymentRailIcon = ({ railId, className = "h-3.5 w-3.5" }) => {
  const Icon = RAIL_ICONS[railId] ?? TbBuildingBank;
  return <Icon className={`shrink-0 text-[#e7a73f] dark:text-brand-gold-mid ${className}`} aria-hidden />;
};
